import { getSameEventAndEffect } from '@ynap/analytics'

export const trackEditPersonalInformation = () => getSameEventAndEffect('edit personal information')

export const trackEditEmailAddress = () => getSameEventAndEffect('edit email address')

export const trackEditPassword = () => getSameEventAndEffect('edit password')
